import React from 'react';
import { Spinner } from '@/Components/shadcn';
import { ClientOverviewResponse } from '@/DTO/Clients/ClientOverviewResponse';
import { resourceBaseUrl } from '@/AppSettings';
import { useCompanyContext } from '@/Context/CompanyContext';
import PaginationConsts from '@/Utils/PaginationConsts';
import { useClientsOverviewContext } from '../contexts/ClientsOverviewContext';
import ClientCard from './ClientCard';
import ClientsOverviewPaginationShadcn from './ClientsOverviewPagination';
import ClientFormDialog from './ClientForm/ClientFormDialog';
import useClientsOverviewActions from './useClientsOverviewAction';

const ClientsOverviewCards = () => {
    const { pagination, clients, isClientsLoading } = useClientsOverviewContext();
    const {
        handleUpdateClientSubmit,
        open,
        setClientToEdit,
        setOpen,
        clientToEdit,
        handleUpdateClientIconSubmit,
        handleResetClientIconSubmit,
    } = useClientsOverviewActions();
    const { currentCompanyProfile } = useCompanyContext();
    const clientIconPlaceholder = `${resourceBaseUrl}/clients/client_placeholder.svg`;

    const getCurrentClientIconURL = (client: ClientOverviewResponse): string => {
        if (client.isDefault && currentCompanyProfile.companyIconURL !== '') {
            return currentCompanyProfile.companyIconURL;
        }
        return client.iconURL ?? clientIconPlaceholder;
    };

    const getCurrentClientName = (client: ClientOverviewResponse): string => {
        if (client.isDefault) {
            return currentCompanyProfile.companyName;
        }
        return client.name;
    };

    if (isClientsLoading) {
        return (
            <div
                data-testid="clientsOverviewCardsSpinnerContainer"
                className="flex h-full min-h-50 items-center justify-center"
            >
                <Spinner role="progressbar" className="text-primary size-8" />
            </div>
        );
    }

    return (
        <div className="flex h-full flex-col gap-6">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-cy="ClientCards">
                {clients?.map((client) => (
                    <ClientCard
                        key={client.id}
                        onEditClient={(cl) => {
                            setClientToEdit({ ...cl, iconURL: client.iconURL });
                            setOpen(true);
                        }}
                        {...client}
                        name={getCurrentClientName(client)}
                        iconURL={getCurrentClientIconURL(client)}
                    />
                ))}
            </div>
            {pagination.totalCount > PaginationConsts.largePageSize && <ClientsOverviewPaginationShadcn />}
            <ClientFormDialog
                client={clientToEdit}
                open={open}
                onClose={() => setOpen(false)}
                onSubmit={handleUpdateClientSubmit}
                handleUploadImage={handleUpdateClientIconSubmit}
                handleResetImage={handleResetClientIconSubmit}
            />
        </div>
    );
};

export default ClientsOverviewCards;
